export const DeviceRegistryConstants = {
    NOTIFICATION_PLUGIN: 'Notification',
    LOGIN_EVENT: 'LOGIN',
    LOGOUT_EVENT: 'LOGOUT',
    // Notification plugin actions.
    ACTION_GET_TOKEN: 'getToken',
    ACTION_TOKEN_REFRESH: 'onTokenRefresh',
    ACTION_GET_APP_INSTALL_ID: 'getAppInstallId',
    ACTION_SET_APP_INSTALL_ID: 'setAppInstallId',
}
